import React from 'react';
import { LabelingLayout } from './components/LabelingLayout';

interface LabelingLandingProps {
  children?: React.ReactNode;
  selectedSection?: string; // Deprecated: Navigation now handles active state via URL
}

/**
 * LabelingLanding - 海外快递模块的统一布局容器
 * 
 * 这个组件取代了之前的 LabelMainLayout，为所有 labeling 页面提供：
 * 1. 主站导航（由外层 AppLayout 提供）
 * 2. 模块内部导航（通过 LabelingLayout）
 * 
 * 使用方式：
 * <LabelingLanding>
 *   <YourPageContent />
 * </LabelingLanding>
 */
export const LabelingLanding: React.FC<LabelingLandingProps> = ({ children }) => {
  return (
    <LabelingLayout>
      {children}
    </LabelingLayout>
  );
};

export default LabelingLanding;
